module.exports = __webpack_public_path__ + "img/SilverCup.76add981.svg";